/**
 * Item service API
 *
 * Contact:
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImageContentShared } from './imageContentShared';
import { SimpleImage } from './simpleImage';


export interface CategoryTreeNodeResponse {
    id?: number;
    parentId?: number;
    title?: string;
    alias?: string;
    categoryType?: CategoryTreeNodeResponse.CategoryTypeEnum;
    visible?: boolean;
    verificationRequired?: boolean;
    image?: SimpleImage;
    imageContent?: ImageContentShared;
    children?: Array<CategoryTreeNodeResponse>;
    itemsCount?: number;
    depthLvl?: number;
    sortOrder?: number;
    metaTitle?: string;
    h1Header?: string;
    description?: string;
    declarationDescription?: string;
    metaDescription?: string;
    metaKeywords?: string;
    itemMetaDescription?: string;
    itemMetaTitle?: string;
    itemMetaKeywords?: string;
    portalDeterminate?: CategoryTreeNodeResponse.PortalDeterminateEnum;
    commissionMinPercent?: number;
    commissionMaxPercent?: number;
    commissionNotLessThan?: number;
    cooldownReturnPeriod?: string;
    warrantyReturnPeriod?: string;
    relatedItemLineSetId?: number;
}
export namespace CategoryTreeNodeResponse {
    export type CategoryTypeEnum = 'ITEMS' | 'SERVICES' | 'FINANCIAL_ITEMS';
    export const CategoryTypeEnum = {
        ITEMS: 'ITEMS' as CategoryTypeEnum,
        SERVICES: 'SERVICES' as CategoryTypeEnum,
        FINANCIAL_ITEMS: 'FINANCIAL_ITEMS' as CategoryTypeEnum
    };
    export type PortalDeterminateEnum = 'COMMON';
    export const PortalDeterminateEnum = {
        COMMON: 'COMMON' as PortalDeterminateEnum
    };
}


